<template>
  <div class="pay-invoice-page">
    <invoice-fixed-header :show-page-title="true"></invoice-fixed-header>

    <div class="center-content">
      <!-- 选择支付方式 -->
      <div class="pay-type-select" v-show="page === 0">
        <div class="pay-top">
          <div class="pay-tips">
            <img
              src="../../assets/imgs/invoice-manage/icon-lock.png"
              class="pay-lock-icon"
            />
            <div class="pay-tips-text">所有支付信息已获得安全加密保护</div>
          </div>
          <div class="pay-types">
            <div
              class="pay-type-item"
              :class="{ selected: paymentType === 1, unselected: paymentType === 0 }"
              @click="paymentType = 1"
            >
              <div class="radio-item"></div>
              <div class="type-name">支付宝</div>
              <div class="fill-space"></div>
              <img
                src="../../assets/imgs/invoice-manage/logo-alipay.png"
                class="ali-type"
              />
            </div>
            <div
              class="pay-type-item"
              :class="{ selected: paymentType === 0, unselected: paymentType === 1 }"
              @click="paymentType = 0"
            >
              <div class="radio-item"></div>
              <div class="type-name">微信</div>
              <div class="fill-space"></div>
              <img
                src="../../assets/imgs/invoice-manage/logo-wxpay.png"
                class="wx-type"
              />
            </div>
          </div>
        </div>
        <div class="pay-bottom">
          <div class="pay-price-label">应付金额：</div>
          <div class="pay-price-number" v-if="invoice.cash_fee">¥ {{ (invoice.cash_fee / 100).toFixed(2) }}</div>
          <div class="fill-space"></div>
          <div class="go-pay-now" @click="payInvoiceNow">前往支付</div>
        </div>
      </div>

      <!-- 进行支付 -->
      <div class="pay-now-box" v-show="page === 1">
        <div class="pay-now-header">
          <img
            src="../../assets/imgs/invoice-manage/logo-alipay.png"
            class="ali-type-img"
            v-show="paymentType === 1"
          />
          <img
            src="../../assets/imgs/invoice-manage/logo-wxpay.png"
            class="wx-type-img"
            v-show="paymentType === 0"
          />
          <div class="fill-space"></div>
          <div class="need-pay-label">应付金额：</div>
          <div class="need-pay-number" v-if="invoice.cash_fee">¥ {{ (invoice.cash_fee / 100).toFixed(2) }}</div>
        </div>
        <div class="pay-now-body">
          <div class="pay-qrcode-box">
            <div class="pay-qrcode">
              <qrcode :options="qrOption" v-if="qrCodeUrl"></qrcode>
            </div>
            <div class="qrcode-tips">
              请使用{{ paymentType === 1 ? "支付宝" : "微信" }}扫一扫
            </div>
            <div class="qrcode-tips last-tips">扫描二维码支付</div>
          </div>
          <div class="pay-help-img">
            <img
              src="../../assets/imgs/invoice-manage/guide-alipay.png"
              class="alipay-help-img"
              v-show="paymentType === 1"
            />
            <img
              src="../../assets/imgs/invoice-manage/guide-wxpay.png"
              class="wx-help-img"
              v-show="paymentType === 0"
            />
          </div>
        </div>
        <div class="pay-now-footer">
          <div class="go-back" @click="goBack">
            &lt;&nbsp;选择其他支付方式
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qrcode from 'qrcanvas-vue';
import invoiceFixedHeader from './components/invoice-fixed-header';
import invoiceApi from '../../api/invoice-api';
import utils from '../../libs/utils';

export default {
  name: 'pay-invoice-page',
  components: {
    qrcode,
    invoiceFixedHeader,
  },
  data() {
    return {
      page: 0,
      paymentType: 1,
      orderInvoiceId: +this.$route.params.id,
      qrCodeUrl: '',
      timer: null,
      invoice: {},
    };
  },
  computed: {
    qrOption() {
      return {
        data: this.qrCodeUrl,
        size: 600,
        correctLevel: 'H',
      };
    },
  },
  methods: {

    // 点击立即支付
    payInvoiceNow() {
      invoiceApi.invoicePay({
        cash_fee: this.invoice.cash_fee,
        payment_type: this.paymentType,
        order_invoice_id: this.orderInvoiceId,
      }).then((data) => {
        this.page = 1;
        this.qrCodeUrl = data.qrcode_url;
        this.startQueryResult();
      }).catch((err) => {
        utils.msg.error(err && err.msg ? err.msg : '提交发票信息失败, 请重试');
        setTimeout(() => {
          if (err && err.msg && err.msg.indexOf('支付价格已变更') > -1) {
            location.reload();
          }
        }, 2000);
      });
    },

    // 开始查询
    startQueryResult() {
      this.timer = setInterval(() => {
        invoiceApi.invoicePayQuery({
          order_invoice_id: this.orderInvoiceId,
        }).then((data) => {

          // 支付成功
          if (data.status) {
            clearInterval(this.timer);
            this.$router.replace({
              name: 'payInvoiceSuccess',
            });
          }
        });
      }, 1000);
    },

    // 返回
    goBack() {
      this.qrCodeUrl = '';
      this.page = 0;
      clearInterval(this.timer);
    },

    // 发票详情
    getInvoiceDetail() {
      invoiceApi.invoiceQuery({
        order_invoice_id: this.orderInvoiceId,
      }).then((data) => {
        this.invoice = data;

        // 已支付或已退款, 直接回到发票历史
        if (data.pay_status > 0) {
          this.$router.replace({
            name: 'invoiceManage',
            query: {
              tab: 'historyInvoices',
            },
          });
        }
      });
    },
  },
  destory() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  created() {
    this.getInvoiceDetail();
  },
};
</script>

<style lang="less" scoped>
.pay-invoice-page {
  display: flex;
  flex-direction: column;
  .center-content {
    width: 800px;
    margin: 0 auto;
    margin-top: 20px;
    background: #ffffff;
    box-shadow: 0px 8px 16px -4px rgba(34, 38, 46, 0.08);
    border-radius: 2px;
    .pay-type-select {
      display: flex;
      flex-direction: column;
      .pay-top {
        padding: 20px;
        display: flex;
        width: 100%;
        flex-direction: column;
        .pay-tips {
          height: 36px;
          background: #eaf1ff;
          padding: 0 12px;
          display: flex;
          width: 100%;
          align-items: center;
          .pay-lock-icon {
            width: 20px;
            height: 20px;
          }
          .pay-tips-text {
            margin-left: 8px;
            font-size: 14px;
            color: #4083ff;
            line-height: 21px;
          }
        }
        .pay-types {
          display: flex;
          flex-direction: column;
          width: 100%;
          margin-top: 20px;
          margin-bottom: 65px;
          .pay-type-item {
            cursor: pointer;
            display: flex;
            align-items: center;
            height: 88px;
            background: #ffffff;
            padding: 0 16px;
            .radio-item {
              width: 24px;
              height: 24px;
              background-repeat: no-repeat;
              background-position: center center;
              background-size: 100% 100%;
            }
            &.selected {
              border-radius: 1px;
              border: 3px solid #eaecf0;
              .radio-item {
                background-image: url("../../assets/imgs/invoice-manage/icon-selected.png");
              }
            }
            &.unselected {
              border-radius: 1px;
              border: 3px solid white;
              .radio-item {
                background-image: url("../../assets/imgs/invoice-manage/icon-unselected.png");
              }
            }
            .type-name {
              margin-left: 18px;
              font-size: 16px;
              font-weight: 500;
              color: #22262e;
              line-height: 22px;
            }
            .fill-space {
              flex: 1;
            }
            .ali-type {
              width: 80px;
              height: 30px;
            }
            .wx-type {
              width: 107px;
              height: 30px;
            }
          }
        }
      }
      .pay-bottom {
        display: flex;
        align-items: center;
        width: 100%;
        height: 98px;
        background: #ffffff;
        box-shadow: 0px -4px 12px -4px rgba(34, 38, 46, 0.08);
        border-radius: 2px;
        padding: 0 20px 0 36px;
        .pay-price-label {
          font-size: 16px;
          font-weight: 500;
          color: #22262e;
          line-height: 22px;
        }
        .pay-price-number {
          margin-left: 8px;
          font-size: 28px;
          font-weight: 500;
          color: #fb8339;
          line-height: 40px;
        }
        .fill-space {
          flex: 1;
        }
        .go-pay-now {
          cursor: pointer;
          width: 271px;
          height: 48px;
          background: #fb8339;
          border-radius: 2px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          font-weight: 500;
          color: #ffffff;
          line-height: 22px;
        }
      }
    }
    .pay-now-box {
      display: flex;
      flex-direction: column;
      .pay-now-header {
        display: flex;
        align-items: center;
        height: 60px;
        border-bottom: 1px solid #eaecf0;
        padding: 0 20px;
        .ali-type-img {
          width: 80px;
          height: 30px;
        }
        .wx-type-img {
          width: 107px;
          height: 30px;
        }
        .fill-space {
          flex: 1;
        }
        .need-pay-label {
          font-size: 14px;
          font-weight: 500;
          color: #22262e;
          line-height: 20px;
        }
        .need-pay-number {
          font-size: 20px;
          font-weight: 500;
          color: #fb8339;
          line-height: 28px;
        }
      }
      .pay-now-body {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 46px;
        .pay-qrcode-box {
          width: 240px;
          height: 296px;
          background: #ffffff;
          border: 2px solid #eaecf0;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 20px 20px 16px 20px;
          .pay-qrcode {
            width: 200px;
            height: 200px;
            display: flex;
            align-items: center;
            justify-content: center;
            canvas {
              width: 190px;
              height: 190px;
            }
          }
          .qrcode-tips {
            margin-top: 10px;
            font-size: 16px;
            font-weight: 500;
            color: #22262e;
            line-height: 22px;
            &.last-tips {
              margin-top: 6px;
            }
          }
        }
        .pay-help-img {
          width: 280px;
          height: 393px;
          margin-left: 80px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .pay-now-footer {
        margin-top: 32px;
        margin-bottom: 40px;
        margin-left: 40px;
        .go-back {
          cursor: pointer;
          font-size: 14px;
          font-weight: 400;
          color: #375bbb;
          line-height: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice-manage/PayInvoice.vue